import { XMarkIcon } from '@heroicons/react/20/solid'
import {useEffect, useState} from "react";
import {
    currentAvailability,
    currentHolidayCTA,
    currentHolidayShort,
    isHolidayFocus
} from "../../models/variableCopywriting";

export default function FixedBanner() {
    // Floating banner at the bottom of page
    
    const [isVisible, setIsVisible] = useState(true);
    useEffect(() => {
        if (isHolidayFocus) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    }, []);
    return (
        <>
            <div className="pointer-events-none fixed inset-x-0 bottom-0 sm:flex sm:justify-center sm:px-6 sm:pb-5 lg:px-8">
                <div className="pointer-events-auto flex gap-x-6 bg-gray-900 px-6 py-2.5 sm:rounded-xl sm:py-3 sm:pr-3.5 sm:pl-4" style={{
                    marginBottom: '0px',
                    paddingBottom: '0px',
                    display: isVisible ? 'flex' : 'none',
                }}>
                    <p className="text-sm/6 text-white">
                        <div className="flex cursor-pointer" onClick={() => {
                            // TODO: Add the item to the cart and go to the cart page (or the checkout page)
                            window.open(currentHolidayCTA, "_blank")
                        }}>
                            <div>
                                <strong className="font-semibold">
                                    Submit {currentHolidayShort} application
                                </strong>
                                <svg viewBox="0 0 2 2" aria-hidden="true" className="mx-2 inline size-0.5 fill-current">
                                    <circle r={1} cx={1} cy={1}/>
                                </svg>
                            </div>
                            <div className="items-end flex ">
                                Only {currentAvailability} slots remaining &nbsp;
                                <span aria-hidden="true" className="items-end ">&rarr;</span>
                            </div>
                        </div>
                    </p>
                    <div className="">
                        <button type="button" className="flex p-1.5 pb-0" onClick={() => {
                            // Makes the view invisible
                            setIsVisible(false)
                        }}>
                            <span className="sr-only">Dismiss</span>
                            <XMarkIcon aria-hidden="true" className="size-5 text-white"/>
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}
